"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelectorContainer = void 0;

var styled_components_1 = __importStar(require("styled-components"));

exports.CountrySelectorContainer = styled_components_1.default.div(function (_a) {
  var hide = _a.hide;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition: max-height 180ms ease-out;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    max-height: ", "px;\n  "], ["\n    transition: max-height 180ms ease-out;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    max-height: ", "px;\n  "])), hide ? 0 : 120);
});
var templateObject_1;